define('components/decorators/email',[
    'jquery'
], function($) {
    $.extend(companyInfo.decorators, {

        /**
         * in this element only show the email addresses and create a link
         * wordwrap the element
         */
        'filteremails': function(e) {

          var component = $(this);
          var string = component.html();
          var reg = /[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+/gi;
          var matches = [];
          var found;
          var html="";

          do {
            found = reg.exec(string);
            if (found) {
              var email = found[0];
              html += '<a title="' + email + '" href="mailto:'+email+'" class="ellipsis-block">'+email+'</a>'; 
            }
          } while (found);
          component.html(html);
          component.removeClass("hidden");
        }
    });

});

